<template>
  <ml-dialog
    width="600px"
    ref="dialogRef"
    :title="title"
    :btnLoading="btnLoading"
    @click-submit="submitHandle"
    @click-close="closeHandle"
  >
    <template #body>
      <ml-form
        labelWidth="120px"
        style="width: 100%"
        :model="dialogData"
        ref="bindDialogFormRef"
        :rules="dialogFormRule"
      >
        <ml-input
          prop="errorContent"
          placeholder="请输入故障现象"
          label="故障现象:"
          v-model="dialogData.errorContent"
        />
        <ml-input
          prop="errorReason"
          placeholder="请输入故障原因"
          label="故障原因:"
          v-model="dialogData.errorReason"
        />
        <ml-input
          prop="errorProcess"
          placeholder="请输入故障处理"
          label="故障处理:"
          v-model="dialogData.errorProcess"
        />
        <ml-date-picker
          prop="errorTime"
          placeholder="请选择故障日期"
          label="故障日期:"
          type="date"
          value-format="YYYY-MM-DD"
          v-model="dialogData.errorTime"
        />
        <ml-date-picker
          prop="errorProcessTime"
          placeholder="请选择故障处理日期"
          label="故障处理日期:"
          type="date"
          value-format="YYYY-MM-DD"
          v-model="dialogData.errorProcessTime"
        />
        <!-- <ml-select
          prop="userList"
          placeholder="请选择运维人员"
          :options="userOptions"
          multiple
          filterable
          label="运维人员:"
          keyName="userId"
          labelName="userName"
          valueName="userId"
          v-model="dialogData.userList"
        /> -->
      </ml-form>
    </template>
  </ml-dialog>
</template>

<script>
import { computed, nextTick, onMounted, reactive, ref } from 'vue'
import { getTabberData, searchParams } from '@/utils'
import { useStore } from 'vuex'
export default {
  name: 'supplementDialog',
  props: {
    deviceId: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  setup(props, context) {
    const { dispatch, commit } = useStore()
    const title = ref('补录信息')
    let btnLoading = ref(false)
    const dialogRef = ref(null)
    const bindDialogFormRef = ref(null)

    const userOptions = ref([])

    const dialogData = reactive({
      id: '',
      errorContent: '',
      deviceId: '',
      userList: [],
      errorTime: '',
      errorProcess: '',
      errorReason: '',
      errorProcessTime: ''
    })
    const dialogFormRule = {
      errorContent: [{ required: true, message: '请输入故障现象', trigger: 'blur' }],
      errorProcess: [{ required: true, message: '请输入故障处理', trigger: 'blur' }],
      errorTime: [{ required: true, message: '请选择故障日期', trigger: 'blur' }],
      errorReason: [{ required: true, message: '请输入故障原因', trigger: 'blur' }],
      errorProcessTime: [{ required: true, message: '请选择故障处理日期', trigger: 'blur' }]
      // userList: [{ required: true, message: '请选择运维人员', trigger: 'change' }]
    }

    // 人搜索条件
    const assignedPeopleForm = reactive({
      userCodeLike: '',
      userNameLike: '',
      companyId: '',
      pageIndex: 1,
      pageSize: 5000
    })
    const getUserOptions = async (params = {}) => {
      const searchDataParams = searchParams(assignedPeopleForm)
      const { data } = await getTabberData(dispatch, 'fetchGetAppUsers', params, searchDataParams)
      userOptions.value = data
    }

    const submitHandle = () => {
      bindDialogFormRef.value.CustomFormRef.validate().then(() => {
        let params = {
          ...dialogData,
          deviceId: props.deviceId,
          userList: dialogData.userList.map(d => {
            let item = userOptions.value.find(item => item.userId === d)
            return {
              userId: d,
              userName: (item && item.userName) || ''
            }
          })
        }
        dispatch('fetchInsetOrUpdateSupplement', params).then(data => {
          if (data && data.code === 200) {
            commit('setError', {
              status: true,
              title: data.message,
              message: '正在获取新的数据...',
              type: 'success'
            })
            context.emit('success')
          }
        })
      })
    }
    const closeHandle = () => {
      context.emit('close')
    }
    const init = () => {
      if (props.data && props.data.id) {
        dialogData.deviceId = props.data.deviceId
        dialogData.id = props.data.id
        dialogData.userList = props.data.userList.map(d => d.userId)
        dialogData.errorContent = props.data.errorContent
        dialogData.errorTime = props.data.errorTime
        dialogData.errorProcess = props.data.errorProcess
        dialogData.errorReason = props.data.errorReason
        dialogData.errorProcessTime = props.data.errorProcessTime
      }
    }

    const showSelect = ref(true)
    const userSelectRef = ref(null)
    onMounted(() => {
      getUserOptions()
      init()
    })

    return {
      title,
      btnLoading,
      submitHandle,
      closeHandle,
      dialogData,
      dialogFormRule,
      dialogRef,
      showSelect,
      userSelectRef,
      userOptions,
      bindDialogFormRef,
      init
    }
  }
}
</script>

<style lang="scss" scoped>
.form-box {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.custom-form-box {
  /deep/ .el-form-item__label {
    width: 100px !important;
    white-space: pre-wrap;
  }
}

.name-tag-box {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 5px;
  min-height: 40px;
  max-height: 110px;
  overflow-x: hidden;
  flex: 1;
  margin-right: 12px;
}
.tag-box {
  display: flex;
  align-items: center;
}
</style>